import { useSpecialFunctions } from "../../functions";

const UpcomingRacesTable = ({
  upcomingRaces,
  upcomingRaceSelected,
  setUpcomingRaceSelected,
  setOffRaceSelected,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  setSelectOption,
}) => {
  const { getHoursMinutes } = useSpecialFunctions();
  // This function is called when the user clicks on the upcoming race row.
  const showRaceInfo = (
    raceID,
    trackName,
    trackID,
    raceNumber,
    trackCode,
    raceStatus
  ) => {
    setUpcomingRaceSelected(raceID);
    setOffRaceSelected(0);
    setRefreshInfo(!refreshInfo);
    setRefreshEntries(!refreshEntries);
    setSelectOption(
      trackID,
      trackName,
      raceID,
      raceNumber,
      trackCode,
      "open",
      raceStatus
    );
    document.getElementById("idCollapse" + trackID).classList.add("show");

    // This function is responsible for moving the scroll position to the Track opens when clicking on the upcoming race row.
    const trackElement = document.getElementById("idCollapse" + trackID);
    trackElement.classList.add("show");

    if (trackElement && trackElement.parentNode) {
      const scrollOffset = 50;
      const trackPosition = trackElement.parentNode.offsetTop;
      const scrollToPosition = trackPosition - scrollOffset;

      trackElement.parentNode.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });

      trackElement.parentNode.scrollTop -= scrollToPosition;
    }
  };

  let headers,
    tableContent = [];
  if (upcomingRaces !== null) {
    tableContent = upcomingRaces.map((data, i) => {
      return (
        <tr
          key={data.RaceID}
          style={{ verticalAlign: "middle" }}
          onClick={() =>
            showRaceInfo(
              data.RaceID,
              data.TrackName,
              data.TrackID,
              data.RaceNumber,
              data.TrackCode,
              data.RaceStatus
            )
          }
          className={upcomingRaceSelected === data.RaceID ? "shadedRow" : ""}
        >
          <td
            key={"td" + data.TrackCode}
            style={{
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            {data.TrackCode}
          </td>
          <td
            key={"td" + data.RaceNumber}
            style={{
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            {data.RaceNumber}
          </td>
          <td
            key={"tdPT" + i}
            style={{
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            {getHoursMinutes(data.PostTime)}
          </td>
          <td
            key={"tdMTP" + i}
            style={{
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            {data.MTP === 0 ? "POST" : data.MTP + " MTP"}
          </td>
        </tr>
      );
    });
  }

  headers = (
    <tr className="text-center">
      <th>Track</th>
      <th>Race</th>
      <th>PostT</th>
      <th>MTP</th>
    </tr>
  );

  return (
    <>
      <div style={{ overflow: "auto", marginTop: "5px" }}>
        <table className="table table-hover table-sm">
          <thead style={{ position: "sticky", top: "0", background: "white" }}>
            {headers}
          </thead>
          <tbody className="table-sm">{tableContent}</tbody>
        </table>
      </div>
    </>
  );
};

export default UpcomingRacesTable;
